(() => {
  if (window.__yi2cHeaderNavigationReady) return;
  window.__yi2cHeaderNavigationReady = true;

  const header = document.querySelector('.yi2c-site-header');
  if (!header) return;

  const desktopGroups = [...header.querySelectorAll('[data-yi2c-nav-group]')];
  const mobileMenu = header.querySelector('[data-yi2c-mobile-menu]');
  const mobileGroups = mobileMenu ? [...mobileMenu.querySelectorAll('[data-yi2c-mobile-group]')] : [];
  const desktopQuery = window.matchMedia('(min-width: 1181px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  let hoverCloseTimer;

  function setDesktopGroup(group, open) {
    const toggle = group.querySelector('[data-yi2c-nav-toggle]');
    const panel = group.querySelector('[data-yi2c-nav-panel]');
    if (!toggle || !panel) return;
    group.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }

  function closeDesktop(except) {
    desktopGroups.forEach((group) => {
      if (group !== except) setDesktopGroup(group, false);
    });
  }

  desktopGroups.forEach((group) => {
    const toggle = group.querySelector('[data-yi2c-nav-toggle]');
    if (!toggle) return;

    // Progressive enhancement: anchor fallback stays usable if JavaScript fails.
    if (toggle.tagName === 'A') {
      toggle.setAttribute('role', 'button');
      toggle.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); toggle.click(); }
      });
    }
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeDesktop(group);
      setDesktopGroup(group, open);
    });

    group.addEventListener('pointerenter', () => {
      if (group.hasAttribute('data-yi2c-click-only') || !desktopQuery.matches || !hoverQuery.matches) return;
      window.clearTimeout(hoverCloseTimer);
      closeDesktop(group);
      setDesktopGroup(group, true);
    });

    group.addEventListener('pointerleave', () => {
      if (group.hasAttribute('data-yi2c-click-only') || !desktopQuery.matches || !hoverQuery.matches) return;
      window.clearTimeout(hoverCloseTimer);
      hoverCloseTimer = window.setTimeout(() => setDesktopGroup(group, false), 140);
    });

    group.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!group.contains(document.activeElement)) setDesktopGroup(group, false);
      }, 0);
    });
    group.querySelectorAll('[data-yi2c-nav-panel] a').forEach(link => {
      link.addEventListener('click', () => setDesktopGroup(group, false));
    });
  });

  function setMobileGroup(group, open) {
    const toggle = group.querySelector('[data-yi2c-mobile-toggle]');
    const panel = group.querySelector('[data-yi2c-mobile-panel]');
    const symbol = toggle?.querySelector('span[aria-hidden="true"]');
    if (!toggle || !panel) return;
    group.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    if (symbol) symbol.textContent = open ? '−' : '+';
  }

  function closeMobileGroups(except) {
    mobileGroups.forEach((group) => {
      if (group !== except) setMobileGroup(group, false);
    });
  }

  mobileGroups.forEach((group) => {
    const toggle = group.querySelector('[data-yi2c-mobile-toggle]');
    if (!toggle) return;
    if (toggle.tagName === 'A') {
      toggle.setAttribute('role', 'button');
      toggle.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); toggle.click(); }
      });
    }
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeMobileGroups(group);
      setMobileGroup(group, open);
    });
  });

  const mobileSummary = mobileMenu?.querySelector('summary');
  function syncMobileMenu() {
    const open = Boolean(mobileMenu?.open);
    mobileSummary?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('yi2c-header-menu-open', open && !desktopQuery.matches);
    if (!open) closeMobileGroups();
  }

  mobileMenu?.addEventListener('toggle', syncMobileMenu);
  mobileMenu?.querySelectorAll('a:not([data-yi2c-mobile-toggle])').forEach((link) => {
    link.addEventListener('click', () => {
      closeMobileGroups();
      mobileMenu.open = false;
      document.body.classList.remove('yi2c-header-menu-open');
    });
  });
  mobileMenu?.addEventListener('focusout', (event) => {
    // Safari touch can blur a control without focusing the tapped button.
    // Only keyboard/focus movement to another element should dismiss here.
    if (!event.relatedTarget) return;
    window.setTimeout(() => {
      if (!mobileMenu.contains(document.activeElement)) mobileMenu.open = false;
    }, 0);
  });

  document.addEventListener('pointerdown', (event) => {
    desktopGroups.filter(group => group.hasAttribute('data-yi2c-click-only')).forEach(group => {
      if (!group.contains(event.target)) setDesktopGroup(group, false);
    });
    // Mobile groups close on click, not pointerdown: collapsing Create here
    // moves the next tapped control before its click can complete.
    if (!header.contains(event.target)) {
      closeDesktop();
      if (mobileMenu?.open) mobileMenu.open = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openDesktop = desktopGroups.find((group) => group.classList.contains('is-open'));
      if (openDesktop) {
        const toggle = openDesktop.querySelector('[data-yi2c-nav-toggle]');
        setDesktopGroup(openDesktop, false);
        toggle?.focus();
        event.preventDefault();
        return;
      }
      if (mobileMenu?.open) {
        const create = mobileGroups.find(group => group.classList.contains('yi2c-create-mobile') && group.classList.contains('is-open'));
        if (create) {
          setMobileGroup(create, false);
          create.querySelector('[data-yi2c-mobile-toggle]')?.focus();
          event.preventDefault();
          return;
        }
        mobileMenu.open = false;
        mobileSummary?.focus();
        event.preventDefault();
      }
      return;
    }

    // Ordinary navigation, not a modal: Tab is never trapped.
  });

  function handleBreakpointChange() {
    if (desktopQuery.matches) {
      if (mobileMenu?.open) mobileMenu.open = false;
      document.body.classList.remove('yi2c-header-menu-open');
    } else {
      closeDesktop();
    }
  }

  desktopQuery.addEventListener('change', handleBreakpointChange);
  syncMobileMenu();
})();
